const IST = 'Asia/Kolkata';

function parts(iso: string, timeZone = IST) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) throw new Error(`labels: bad date ${iso}`);
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone, hour: 'numeric', minute: '2-digit', hour12: true });
  const got = fmt.formatToParts(d);
  const hour = got.find((p) => p.type === 'hour')?.value ?? '';
  const minute = got.find((p) => p.type === 'minute')?.value ?? '';
  const period = (got.find((p) => p.type === 'dayPeriod')?.value ?? '').toLowerCase();
  return { hour, minute, period };
}

/** "9:37 am", "12:00 pm", "3:34 pm" */
export function formatTime(iso: string, timeZone = IST): string {
  const { hour, minute, period } = parts(iso, timeZone);
  return `${hour}:${minute} ${period}`;
}

/**
 * "11:00 to 11:45 am" when both ends share a period, otherwise
 * "11:45 am to 12:30 pm".
 */
export function formatRange(startIso: string, endIso: string, timeZone = IST): string {
  const a = parts(startIso, timeZone);
  const b = parts(endIso, timeZone);
  const left = a.period === b.period ? `${a.hour}:${a.minute}` : `${a.hour}:${a.minute} ${a.period}`;
  return `${left} to ${b.hour}:${b.minute} ${b.period}`;
}

/** "0:08", "2:54", "1:02:03" */
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) throw new Error(`labels: bad duration ${seconds}`);
  const total = Math.round(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}

/** Counts line: "58 clips · 50 photos", singular where it matters. */
export function formatCounts(clips: number, photos: number): string {
  const c = `${clips} ${clips === 1 ? 'clip' : 'clips'}`;
  const p = `${photos} ${photos === 1 ? 'photo' : 'photos'}`;
  return `${c} · ${p}`;
}

/** Download name: time only, never the camera file number (US-05). */
export function downloadName(iso: string, timeZone = IST, extension = 'jpg'): string {
  const d = new Date(iso);
  const day = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  const { hour, minute, period } = parts(iso, timeZone);
  const h24 = (Number(hour) % 12) + (period === 'pm' ? 12 : 0);
  return `seemantham-${day}-${String(h24).padStart(2, '0')}${minute}.${extension}`;
}
